const topics = [
  { name: '#51爆料每日大赛', heat: '98.6万', rank: 1, trend: 'up' },
  { name: '#51吃瓜爆料每日大赛', heat: '87.3万', rank: 2, trend: 'up' },
  { name: '#电竞转会地震', heat: '65.2万', rank: 3, trend: 'up' },
  { name: '#选秀黑幕曝光', heat: '54.8万', rank: 4, trend: 'new' },
  { name: '#体育圈大瓜', heat: '43.1万', rank: 5, trend: 'up' },
  { name: '#游戏新作泄露', heat: '38.7万', rank: 6, trend: 'down' },
  { name: '#明星私密对话', heat: '32.5万', rank: 7, trend: 'up' },
  { name: '#赛事评委内讧', heat: '27.9万', rank: 8, trend: 'new' },
  { name: '#音乐节阵容', heat: '22.4万', rank: 9, trend: 'down' },
  { name: '#奥运冠军风波', heat: '18.6万', rank: 10, trend: 'up' },
];

export default function TopicTags() {
  return (
    <section id="topics" className="section-py bg-background-100">
      <div className="section-container">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center gap-3">
            <div className="w-1 h-6 rounded-full bg-accent-500"></div>
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">
              话题热榜
            </h2>
          </div>
          <span className="text-xs text-foreground-500 flex items-center gap-1">
            <i className="ri-time-line"></i>
            实时更新
          </span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3">
          {topics.map((topic, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-lg border border-background-200/70 p-4 hover:border-accent-300 transition-colors cursor-pointer flex items-center gap-3"
            >
              <span className={`text-lg font-bold font-heading w-7 shrink-0 ${
                idx < 3 ? 'text-accent-500' : 'text-foreground-400'
              }`}>
                {String(topic.rank).padStart(2, '0')}
              </span>
              <div className="min-w-0 flex-1">
                <p className="text-sm font-medium text-foreground-800 truncate">{topic.name}</p>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-xs text-foreground-500">{topic.heat} 热度</span>
                  {topic.trend === 'up' && (
                    <span className="text-xs text-primary-600 flex items-center gap-0.5">
                      <i className="ri-arrow-up-line"></i>
                    </span>
                  )}
                  {topic.trend === 'down' && (
                    <span className="text-xs text-foreground-400 flex items-center gap-0.5">
                      <i className="ri-arrow-down-line"></i>
                    </span>
                  )}
                  {topic.trend === 'new' && (
                    <span className="text-xs bg-accent-100 text-accent-700 px-1.5 py-0.5 rounded font-semibold">新</span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}